import { gql } from '@apollo/client';

/**
 * Выгрузка данных для P&L (ТЗ 0075) — чтение.
 *
 * Имена операций намеренно отличаются от полей бэкенда (`pnlExportRuns`,
 * `pnlExportFile`): при совпадении кодоген схлопывает тип результата.
 *
 * Поля заказа перечислены прямо здесь, без фрагмента: кодоген пропускает
 * `gql` с интерполяцией `${…}`, и хуки молча не появились бы.
 */
export const PnlExportRunsQueryDocument = gql`
  query PnlExportRuns($groupId: ID, $limit: Int) {
    pnlExportRuns(groupId: $groupId, limit: $limit) {
      id
      status
      fileFormat
      language
      monthFrom
      monthTo
      groupId
      groupName
      fileName
      size
      stats
      error
      createdByName
      createdAt
      finishedAt
      isDownloadable
      isFilePurged
    }
  }
`;

/**
 * Группы для селектора на странице `/finances/pnl`, новые сверху, уже в скоупе
 * юрлица сотрудника.
 *
 * Отдельный запрос, а не `groups`/`group`: у FinanceManager нет доступа к
 * обычным запросам групп, и селектор у него остался бы пустым.
 */
export const PnlExportGroupsQueryDocument = gql`
  query PnlExportGroups {
    pnlExportGroups {
      id
      name
      courseName
      startDate
    }
  }
`;

/**
 * Байты готового файла в base64. Запрашивать ТОЛЬКО с `fetchPolicy: 'no-cache'`:
 * `network-only` всё равно пишет ответ в кеш Apollo, а мегабайты base64 там
 * не нужны никому.
 */
export const PnlExportFileQueryDocument = gql`
  query PnlExportFile($id: ID!) {
    pnlExportFile(id: $id) {
      fileName
      contentType
      contentBase64
    }
  }
`;
